<script>
import SearchForm from '@phoenix/mixins/components/search/SearchForm';
import { PhxAutocomplete } from '@phx-styleguides/jlc';
import { debounce } from 'lodash-es';
import { rescue } from '@phoenix/helpers/common-helper';

const MIN_TERM_LENGTH = 3;
const SEARCH_QUERY_DELAY = 400;

export default {
  components: {
    PhxAutocomplete,
  },

  mixins: [SearchForm],

  props: {
    panelId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      inputTimeout: null,
      teleportTarget: {
        '': '.search-teleport-placeholder',
        lg: null,
      },
      onQuery: debounce((value) => {
        let searchTerm = value.trim();

        if (!this.isResultsComponentPresent && searchTerm.length < MIN_TERM_LENGTH) {
          searchTerm = '';
        }

        this.stagedQuery = searchTerm;
        this.search();
      }, SEARCH_QUERY_DELAY),
    };
  },

  computed: {
    dataTarget() {
      return this.panelId && !this.isResultsComponentPresent ? `#${this.panelId}` : null;
    },
    suggestions() {
      if (this.stagedQuery === this.$store.state.search.query) {
        return this.$store.state.search.suggestions;
      }

      return [];
    },
  },

  methods: {
    async search(formSubmitted = false) {
      if (this.isResultsComponentPresent || !formSubmitted) {
        if (this.isResultsComponentPresent) {
          this.updateUrlWithoutReloading();
        }
        await this.setQuery(this.stagedQuery);
      } else {
        window.location.href = `${this.action}?keyword=${this.stagedQuery}`;
      }
    },

    onPressEnter() {
      this.search(true);
    },

    onChange(option) {
      if (!option) {
        return;
      }

      this.stagedQuery = option.value;
      this.search(true);

      rescue(() => {
        const event = window.tracking?.getSearchQuerySuggestion?.(option.value);
        if (event) {
          window.tracking.pushEvent(event);
        }
      });
    },
  },
};
</script>

<template>
  <form class="search-form" autocomplete="off" @submit.prevent="search(true)">
    <div class="nav-search__autocomplete">
      <div id="search-nav-bar-wrapper">
        <phx-autocomplete
          id="search-nav-bar"
          name="search-nav-bar"
          hide-label
          clear-button-icon="cross-16"
          open-button-icon="search-16"
          :max-rows="3"
          :min-rows="3"
          label=""
          :placeholder="$t('Search.placeholder')"
          :clear-button-label="$t('Search.clear')"
          :open-button-label="$t('Search.openLabel')"
          :loading-text="$t('Search.loading')"
          no-result-text=""
          display-both-buttons
          :options="suggestions"
          :teleport-target="teleportTarget"
          :force-clear-on-mobile="true"
          :data-attributes="{ target: dataTarget }"
          @autocomplete:query="onQuery"
          @autocomplete:change="onChange"
          @autocomplete:press-enter="onPressEnter"
        >
        </phx-autocomplete>
      </div>
    </div>
  </form>
</template>
